import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-wp-bot-list',
  templateUrl: './wp-bot-list.component.html',
  styleUrls: ['./wp-bot-list.component.css'],
})
export class WpBotListComponent {
  url: string = '';
  data: Array<any> = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 15;
  searchText = '';
  filteredData: Array<any> = [];
  sugerenciasBusqueda: string[] = [];

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-message',
      bgClass: 'bg-white',
      desc: 'WpBot',
      route: '/hub',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-message',
      bgClass: 'bg-white',
      desc: 'BookingBot ',
      route: '/hub/chatbot',
    },
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    console.log('resumenCards', this.resumenCards);
    //this.getData();
  }

  getStats() {
    /* this.totalConductores = this.data.length;
    this.totalActivos = this.data.filter((d) => d.status).length;
    this.totalInactivos = this.data.filter((d) => !d.status).length;
    this.ultimoRegistro = this.data.length
      ? this.data[this.data.length - 1].firstname +
        ' ' +
        this.data[this.data.length - 1].lastname
      : '-'; */
  }

  getResumenEstados() {
    //this.totalNumber = this.data.length;
    /* this.byCities = new Set(this.data.map((d) => d.city)).size;
    this.active = this.data.filter((d) => d.status === 'active').length;
    this.busy = this.data.filter((d) => d.status === 'busy').length;
    this.pending = this.data.filter((d) => d.status === 'pending').length;
    this.sanctioned = this.data.filter((d) => d.status === 'sanctioned').length; */
    /* this.resumenCards[0].value = this.totalConductores;
    this.resumenCards[1].value = 0;
    this.resumenCards[2].value = this.totalActivos;
    this.resumenCards[3].value = this.busy;
    this.resumenCards[4].value = this.totalInactivos;
    this.resumenCards[5].value = this.sanctioned; */
  }

  filterInfo() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          item.description && item.description.toLowerCase().includes(texto)
          //(item.lastname && item.lastname.toLowerCase().includes(texto)) ||
          //(item.phone && item.phone.toLowerCase().includes(texto)) ||
          //(item.role &&
          //  item.role.name &&
          //  item.role.name.toLowerCase().includes(texto)) ||
          //(item.rol_user && item.rol_user.toLowerCase().includes(texto)) ||
          //(item.state && item.state.toLowerCase().includes(texto)) ||
          //(item.city && item.city.toLowerCase().includes(texto))
        );
      });
    }
    this.getStatsFiltrado();
    this.getResumenEstadosFiltrado();
  }

  getStatsFiltrado() {
    /* this.totalConductores = this.filteredData.length;
    this.totalActivos = this.filteredData.filter((d) => d.status).length;
    this.totalInactivos = this.filteredData.filter((d) => !d.status).length;
    this.ultimoRegistro = this.filteredData.length
      ? this.filteredData[this.filteredData.length - 1].firstname +
        ' ' +
        this.filteredData[this.filteredData.length - 1].lastname
      : '-'; */
  }

  getResumenEstadosFiltrado() {
    /* this.totalNumber = this.filteredData.length;
    this.byCities = new Set(this.filteredData.map((d) => d.city)).size;
    this.active = this.filteredData.filter((d) => d.status === 'active').length;
    this.busy = this.filteredData.filter((d) => d.status === 'busy').length;
    this.pending = this.filteredData.filter(
      (d) => d.status === 'pending'
    ).length;
    this.sanctioned = this.filteredData.filter(
      (d) => d.status === 'sanctioned'
    ).length;

    this.resumenCards[0].value = this.totalConductores;
    this.resumenCards[1].value = this.byCities;
    this.resumenCards[2].value = this.totalActivos;
    this.resumenCards[3].value = this.busy;
    this.resumenCards[4].value = this.totalInactivos;
    this.resumenCards[5].value = this.sanctioned; */
  }

  actualizarSugerencias() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.description) sugerenciasSet.add(item.description);
      //if (item.lastname) sugerenciasSet.add(item.lastname);
      //if (item.phone) sugerenciasSet.add(item.phone);
      //if (item.role && item.role.name) sugerenciasSet.add(item.role.name);
      //if (item.rol_user) sugerenciasSet.add(item.rol_user);
      //if (item.state) sugerenciasSet.add(item.state);
      //if (item.city) sugerenciasSet.add(item.city);
    });
    this.sugerenciasBusqueda = Array.from(sugerenciasSet).filter(Boolean);
  }

  /* getData(): void {
    this.dataService.getData(`${this.url}`).subscribe((response) => {
      console.log('response en accounting', response);
      if (response) {
        this.data = response.data;
        this.filteredData = [...this.data];
        console.log('filteredData', this.filteredData);
        this.getStats();
        this.getResumenEstados();
        this.actualizarSugerencias();
      } else {
        this.messageService.add(response.msg, 'danger');
      }
    });
  } */

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        //console.log('response en accounting', response);

        if (response) {
          this.data = response.data;
          this.morePages = response.data.length === this.itemsPerPage;
          this.filteredData = [...this.data];

          this.getStats();
          this.getResumenEstados();
          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  nextPage(): void {
    this.currentPage++;
    this.getData();
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getData();
    }
  }
}
